// extracted by mini-css-extract-plugin
module.exports = {"hero":"SectionContentsHero_hero__3rBtP","text-tertiary":"SectionContentsHero_text-tertiary__12jfW"};